(function (_superfunction) {
    Date.prototype.toString = function (format, language) {
        if (!format) return _superfunction.call(this);

        var langs = {
            'en-US': {
                days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                months: ['Janurary', 'Februrary', 'Marts', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
            },
            'da-DK': {
                days: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
                months: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'july', 'august', 'september', 'october', 'november', 'december']
            }
        }
        var lang = langs[language] || (typeof (navigator) !== 'undefined' ? langs[navigator.language] : false) || langs['en-US'];
        // Standard types
        return format
            .replace(/{yyyy}|{year}/g, this.getYear() + 1900)
            .replace(/{yy}/g, ('0' + (this.getYear() - 100)).slice(-2))
            .replace(/{MMMM}/g, lang.months[this.getMonth()])
            .replace(/{MMM}/g, lang.months[this.getMonth()].substr(0, 3))
            .replace(/{MM}|{month}/g, ('0' + (this.getMonth() + 1)).slice(-2))
            .replace(/{dddd}/g, lang.days[this.getDay()])
            .replace(/{ddd}/g, lang.days[this.getDay()].substr(0, 3))
            .replace(/{dd}|{date}/g, ('0' + this.getDate()).slice(-2))
            .replace(/{d}/g, this.getDate())
            .replace(/{hh}|{hour}/g, ('0' + this.getHours()).slice(-2))
            .replace(/{mm}|{minute}/g, ('0' + this.getMinutes()).slice(-2))
            .replace(/{ss}|{second}/g, ('0' + this.getSeconds()).slice(-2))
            .replace(/{ms}|{millisecond}/g, ('00' + this.getMilliseconds()).slice(-3))
            .replace(/{wd}|{weekday}|{dayofweek}/g, this.getDay())
            .replace(/{time}/g, this.getTime())
            .replace(/{.+}/g, undefined);
    };
})(Date.prototype.toString);